import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {useItemDiscount} from './ItemDiscountContent-hook'

export const ItemDiscountContent = ({itemDiscountData}) => {
  const {itemDiscountJsonSchema, itemDiscountUISchema} = useItemDiscount()
  const getVal = v => v || '-'
  return (
    <div>
      <JsonFormsWrapper
        jsonschema={itemDiscountJsonSchema}
        uischema={itemDiscountUISchema}
        data={{
          name: getVal(itemDiscountData?.name),
          type: getVal(itemDiscountData?.type),
          discountTypeCode: getVal(itemDiscountData?.discountTypeCode),
          value: getVal(itemDiscountData?.value),
          id: getVal(itemDiscountData?.id),
          extOverDiscountPercentage: getVal(itemDiscountData?.extOverDiscountPercentage),
          extOverDiscountValue: getVal(itemDiscountData?.extOverDiscountValue),
          discountAmount: getVal(itemDiscountData?.discountAmount),
          priority: getVal(itemDiscountData?.priority),
        }}
      />
    </div>
  )
}
